module.exports = __webpack_public_path__ + "static/media/alert.4f60e28e.svg";